module.exports = __webpack_public_path__ + "img/jppdimg_mo4.859f3387.png";